<template>
    <div class="container-fluid" v-if="tender.id > 0">
        <div class="row" >
            <div class="col-xl-8">
                <div id="panel-tender" class="panel">
                    <div   class="panel-hdr bg-primary-700 " >
                        <h2>
                            Заявка на тендер № {{ tender.number }} ({{tender.name}})
                        </h2>
                        
                        <div class="panel-toolbar">
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
                        </div>
                    </div>
                    
                    <div class="panel-container collapse show">
                        <div class="panel-content">
                            <application_contragent :tender="tender"></application_contragent>
                            <application_payment :tender="tender"></application_payment>
                            <application_reject :tender="tender"></application_reject>
                            <application_position :tender="tender"></application_position>
                            
                            <application_reduction_info
                                :tender_id="tender_id"
                                :app_id="app_id"
                            >
                            </application_reduction_info>
                            
                            <tender_files_add :tender="tender" :only_view="true"></tender_files_add>
                            
                            <div class="buttons mt-4">
                                
                                <div class="btn btn-primary btn_save_pd waves-effect waves-themed mr-2"
                                     @click="action('accept')">Прийняти заявку
                                </div>
                                
                                <div class="btn btn-outline-danger btn_reject waves-effect waves-themed mr-2"
                                     @click="reject">
                                    Відхилити заявку
                                </div>
                                
                                <div class="btn btn-outline-success btn_history waves-effect waves-themed"
                                    @click="show_history">
                                    Історія повідомлень
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-xl-4">
                <tender_time :now="date" :date-to="tender.date_to" :date-from="tender.date_from"></tender_time>
                <tender_info :tender="tender"></tender_info>
                <tender_payment :tender="tender"></tender_payment>
                <tender_files :tender="tender"></tender_files>
                <tender_header :tender="tender"></tender_header>
            </div>
            
            <reject_reason @send="reject_action" ></reject_reason>
            <application_history
                :tender_id="tender_id"
                :app_id="app_id"
            >
            </application_history>
        </div>
    </div>
</template>

<script>

import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BButtonGroup
} from 'bootstrap-vue-next';
import tender_time from "../../../contragent/tender/tabs/tender_time.vue";
import tender_info from "../../../contragent/tender/tabs/tender_info.vue";
import tender_header from "../../../contragent/tender/tabs/tender_header.vue";
import tender_payment from "../../../contragent/tender/tabs/tender_payment.vue";
import tender_files from "../../../contragent/tender/tabs/tender_files.vue";
import Application_position from "./blocks/application_position.vue";
import Tender_files_add from "../../../contragent/tender/request/tender_files_add.vue";
import Application_contragent from "./blocks/application_contragent.vue";
import Application_reject from "./blocks/application_reject.vue";
import Application_payment from "./blocks/application_payment.vue";
import Reject_reason from "./reject/reject_reason.vue";
import Application_history from "./history/application_history.vue";
import Application_reduction_info from "./reduction/application_reduction_info.vue";


export default {
    name: "application_inside",
    props: {
        tender_id: {
            type: [Number, String],
            required: true
        },
        
        app_id : {
            type: [Number, String],
            default: 0
        },
        
        date : {
            type : String,
            required: true,
        },
    },
    
    components: {
        Application_reduction_info,
        Application_history,
        Reject_reason,
        Application_payment,
        Application_reject,
        Application_contragent,
        Tender_files_add,
        Application_position,
        tender_files,
        tender_payment,
        tender_header,
        tender_info,
        tender_time,
        
        BTab,
        BTabs,
        BOverlay,
        BSpinner,
        BButton,
        BButtonGroup,
    },
    
    data() {
        return {
            is_load: false,
            tender: {},
        }
    },
    created() {
        this.loadTender();
        EventBus.$on('reload_app',this.loadTender);
    },
    
    methods: {
        show_history() {
            EventBus.$emit('show_history');
        },
        reject() {
            EventBus.$emit('reject_show');
        },
        
        reject_action(reason) {
            this.action('reject',{
                'reject_reason' : reason
            })
        },
        
        async action(action,params = null) {
            
            console.log('action',action);
            IMC_CORE.showloading();
            
            let url = "/tenders/sales/tenders/" + parseInt(this.tender_id) + "/applications/" + this.app_id + "/" + action;
            await api.patch(url,params).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    IMC_CORE.snackbar('Виконано');
                    IMC_CORE.hideloading();
                    EventBus.$emit('reload_app');
                }
            }).catch(response => {
                IMC_CORE.hideloading();
                console.log(response);
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        async loadTender() {
            this.is_load = true;
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender_id) + "/applications/" + this.app_id).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.tender = data.data;
                    this.tender.app_id = this.app_id;
                    
                    if(this.tender.hasOwnProperty('status')) {
                        if (this.tender.status != 'published') {
                            this.only_view = true;
                        }
                    }
                    
                    if(!this.tender.hasOwnProperty("request")) {
                        this.tender.request = {
                            files : [],
                            payment : {},
                            positions : [],
                        }
                    }
                    else {
                        let request_status = this.tender.request?.status;
                        if(request_status !== 'new') {
                            this.only_view = true;
                        }
                    }
                }
            }).catch(response => {
                console.log(response);
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
    
}
</script>



<style scoped>

</style>